export default defineAppConfig({
  ui: {
    colors: {
      primary: 'acc',
      secondary: 'accdark',
      success: 'green',
      error: 'accred',
      warning: 'accyellow',
      info: 'blue',
      neutral: 'zinc',
    },
    pagination: {
      slots: {
        first: 'disabled:opacity-30',
        prev: 'disabled:opacity-30',
        next: 'disabled:opacity-30',
        last: 'disabled:opacity-30',
      },
    },
  },
})
